__webpack_require__.p = "https://bmidxbnetherlandsplprod.netlify.app/";